import { render } from "./BaseCheckbox.vue?vue&type=template&id=5dd35fde"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script